<template>
    <div class="home">
        <page1 ref="p1" />
        <page2 ref="p2" />
        <page3 ref="p3" />
        <page4 ref="p4" />

    </div>
</template>

<script>

    import Page1 from './slot/Page1';
    import Page2 from './slot/Page2';
    import Page3 from './slot/Page3';
    import Page4 from './slot/Page4';



    export default {
        name: 'Home_de',
        components: {
            Page1,Page2,Page3,Page4

        },
        metaInfo: {
            title: 'High Power Ferrite Core, Soft Ferrite Core, Manganese Zink Ferrite Core, Nanjing Hengchuang Magnetoelectronics Co., Ltd., Powered by MeCMS', // set a title
            meta: [{
                // 设置meta信息
                name: 'High-Power Ferrit Kern, High-Power Kern, Weichferrit Kern, Mangan Zink Ferrit Kern',
                content: 'Hochleistungsmagnetkerne, Nanjing Hengchuang Magnetoelektronics spezialisiert sich auf die Herstellung verschiedener hochwertiger großer magnetischer Kerne, ' +
                    'Hochleistungsferritkerne, Weichferritkerne, Mangan-Zink-Ferritkerne, großformatige Kerne, Röntgenkerne und Hochspannungstransformatorkerne Tel: 18913981759'
            }]
        },
        beforeRouteLeave(){
            this.$refs.p2.DestroyListener()
            this.$refs.p3.DestroyListener()
            this.$refs.p4.DestroyListener()

        },



    }
</script>
<style scoped>
    .home{
        padding: 0;
        margin: 0;
        overflow-y: hidden;
        background-image: url("../assets/page2.jpg");
        background-attachment: fixed;
    }
    .home::-webkit-scrollbar{
        display: none;
    }
</style>